import { HStack, VStack, Text, Box } from '@chakra-ui/react';

import Const from '../Constants';

/*
  One settings line: label (+ optional description) on the left, a control on the
  right. Pass the control as children (a Button, Select, Switch, status Text…).
  This is the unit every future user-config reuses.
*/
const SettingsRow = ({ label, description, children }) => {
  return (
    <HStack justify={'space-between'} align={'center'} w={'100%'} spacing={Const.SpaceMD}>
      <VStack align={'start'} spacing={0} minW={0}>
        <Text fontSize={Const.SM} fontWeight={Const.Bold} color={Const.White}>
          {label}
        </Text>
        {description && (
          <Text fontSize={Const.XS} color={Const.Gray165}>
            {description}
          </Text>
        )}
      </VStack>

      {children && <Box flexShrink={0}>{children}</Box>}
    </HStack>
  );
};

export default SettingsRow;
